import domReady from "@roots/sage/client/dom-ready";
import SubstrateCalculator from "@scripts/components/substrate-calculator/SubstrateCalculator.js";

/**
 * Initialize Substrate Calculator on single product pages and calculator page
 */
const initSubstrateCalculator = () => {
    // Try product page first (single-product-section.blade.php)
    let calculatorElement = document.querySelector('#substrate-calculator');

    // Fallback to calculator page (template-calculator.blade.php)
    if (!calculatorElement) {
        calculatorElement = document.querySelector('[data-substrate-calculator="root"]');
    }

    if (calculatorElement) {
        new SubstrateCalculator(calculatorElement);
    }
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(() => {
    initSubstrateCalculator();
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
